import React, { useState, useEffect } from 'react'

import './styles.scss'
import iconChecked from 'assets/images/checkmark-rounded-61CEF7.svg'
import iconUnchecked from 'assets/images/checkbox-gray-0.svg'
import iconArrowDown from 'assets/images/arrow_down.svg'

import {
    Loader,
    SearchField,
    Select, SelectDropDown, SelectGroup, SelectOption,
    VMenu, MenuOption,
    Pagination
} from 'components'
import { UserListItem } from './user-list-item'

import {
    useAlert,
    User,
    AdminCurrentUsersProvider, useAdminCurrentUsers, useAdminDeletedUsers, AdminUser, AdminUserTag
} from 'core'
import { ArrayHelper, ObjectHelper } from 'utils'

export function AdminLockrPayWithrawlsElement({ }) {
    const { setError } = useAlert()
    const { isLoading, totalCount, currentUsers, adminCurrentUsersSearch } = useAdminCurrentUsers()
    const [searchText, setSearchText] = useState('')
    const [pageNum, setPageNum] = useState(0)
    const [pageSize, setPageSize] = useState(5)
    const [sortBy, setSortBy] = useState('createdAt')	// "createdAt"|"-loginCount"|"loginCount"|"-mailCount"|"mailCount"|"senderCount"|"refSent"|"refEarned"|"permalink"
    const [autoBlock, setAutoBlock] = useState(null)
    const [allowConsent, setAllowConsent] = useState(0)
    const [extensionInstalled, setExtensionInstalled] = useState(0)
    const [lockrPayWithdrawls, setLockrPayWithdrawls] = React.useState([]);

    React.useEffect(() => {
        getWitdrawls()
    }, [sortBy, pageNum, pageSize])

    const getWitdrawls = async () => {
        let res = await AdminUser.getLockrPayWithdrawls(pageNum, pageSize, sortBy)
        setLockrPayWithdrawls(res)
    }



    return (
        <div className="admin-current-users">

            <div className="header">
                <Select
                    value={sortBy}
                    onChange={value => setSortBy(value)}>
                    <SelectOption value="createdAt">Most Recent</SelectOption>
                    <SelectOption value="amount">Amount</SelectOption>


                </Select>
            </div>
            <div className="list">
                <UserListItem isHeader />
                {isLoading ? <Loader /> :
                    lockrPayWithdrawls?.map((user, index) =>
                        <UserListItem
                            key={index}
                            user={user}
                        />
                    )
                }
            </div>
            <Pagination
                className="admin-current-users-pagination"
                totalSize={totalCount}
                pageIndex={pageNum}
                pageSize={pageSize}
                onPageIndex={value => setPageNum(value)}
                onPageSize={value => setPageSize(value)}
            />
        </div>
    )
}